import React, { useState } from "react";
import { connect } from "react-redux";

import Dropdown from "antd/es/dropdown";
import { useIntl } from "react-intl";

import ButtonLink from "@app/component/ButtonLink";
import FrequencyCollapsePanel from "@app/component/frequency/FrequencyCollapsePanel";
import CustomFrequencySelector from "@app/component/frequency/FrequencySelector/CustomFrequencySelector";
import FrequencyEntity from "@app/component/frequency/type/FrequencyEntity";
import { getFrequencyPanelConfigEntity, isFrequencyPanelLoading } from "@app/store/frequency";
import { RootState } from "@app/store/rootReducer";

import Loader from "../Loader";

import styles from "./GroupFrequencyState.module.scss";

interface Props {
  entity: FrequencyEntity;
  loading: boolean;
}

const GroupFrequencyState: React.FC<Props> = ({ entity, loading }) => {
  const intl = useIntl();

  const [menuVisible, setMenuVisibility] = useState<boolean>(false);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className={styles.container}>
      <FrequencyCollapsePanel
        header={intl.formatMessage(
          {
            id: "frequency.cadenceSelector.groupInfo.title",
            defaultMessage: "{count} {count, plural, one {Day} other {Days}} Frequency",
            description: "frequency component - group title",
          },
          { count: entity.cadenceInterval }
        )}
        isOpenByDefault
      >
        <div className={styles.content}>
          <div className={styles.description}>
            {intl.formatMessage({
              id: "frequency.cadenceSelector.groupInfo.description",
              defaultMessage: "Each record in this group will inherit this frequency",
              description: "frequency component - group description",
            })}
          </div>
          <div className={styles.manageFrequencyContainer}>
            <Dropdown
              onVisibleChange={setMenuVisibility}
              overlay={
                <CustomFrequencySelector
                  entity={entity}
                  isGroup
                  onHide={() => setMenuVisibility(false)}
                />
              }
              placement="bottomLeft"
              trigger={["click"]}
              visible={menuVisible}
            >
              <ButtonLink className={styles.link}>
                {intl.formatMessage({
                  id: "frequency.cadenceSelector.groupInfo.manage",
                  defaultMessage: "Manage Frequency",
                  description: "frequency component - group description - Manage Frequency",
                })}
              </ButtonLink>
            </Dropdown>
          </div>
        </div>
      </FrequencyCollapsePanel>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  entity: getFrequencyPanelConfigEntity(state),
  loading: isFrequencyPanelLoading(state),
});

export default connect(mapStateToProps)(GroupFrequencyState);
